export const tokenNearExpiry = timeExpires => {
  const now = new Date();
  const diff = timeExpires - now.getTime();

  return Math.round(diff / 1000) <= 5 * 60; // (5 min or less to live)
};
